import { gql } from "apollo-boost";

const RESEND_EMAIL_TEMPLATE = gql`
  query sendEmailVerificationCode {
    sendEmailVerificationCode {
      status
      message
    }
  }
`;

export default RESEND_EMAIL_TEMPLATE;
